storefrontApp.service('favoritesElasticService', function () {
    this.buildBrands = function (design,free) {
            if(!free){
                return (
                    req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + design +'"}},{"range":{"listPrice":{"gt":0}}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                )
            }
            else{
                return (
                    req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + design + '"}},{"term":{"listPrice":0}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                )
            }
       
    },
        
        this.buildBrandSampleInfoRequest = function (brands, size,free) {
                if(!free){
                    return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"range": {"listPrice": {"gt": 0}}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                        + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                    )
                    }
                     else{
                            return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"term": {"listPrice":0}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                        + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                        )
                    }
          
        },
        this.buildBrandDefinitionsInfoRequest = function (brands, size,free) {
                if(!free){
                    return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}}],"must_not": [{"terms": {"definitionName": [ "SVG" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                        + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                    )
                    }
                    else{
                        return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}},{"term": {"listPrice":0}}], "must_not": [{"terms": {"definitionName": [ "SVG","Font","DesignPack" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                        + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                        )   
                    }

        }
});
